import React from 'react';
import PropTypes from 'prop-types';
import './style.css'

/**
 * @name ActivityIndicator
 * @function
 * @returns {JSX}
 * @description Displays an activity indicator on the page
 * @param {Object} props 
 */
const ActivityIndicator = props => {

    let classList = [ 'fas', 'fa-circle-o-notch', 'fa-spin' ];

    if( props.spinnerClasses ) classList.push( ...props.spinnerClasses );

    return (
        <div className="loading">
            <i className={ classList.join( ' ' ) } />
            { props.text }
        </div>
    );
}

ActivityIndicator.propTypes = {
    spinnerClasses: PropTypes.array,
    text: PropTypes.string
}

export default ActivityIndicator;